import request from "./request";

const opportunity = {
  service() {
    return {
      get(id) {
        return request.get(`/interviews-api/opportunities/${id}`);
      },
      patch(id, data) {
        return request.patch(`/interviews-api/opportunities/${id}`, data);
      },
      list(params) {
        params.pageIndex = params.pageIndex ? params.pageIndex : 0;
        params.pageSize = params.pageSize ? params.pageSize : 10;

        return request.get("/interviews-api/opportunities", params);
      },
      search(params) {
        return request
          .get("/interviews-api/opportunities/search", params)
          .then((resp) => {
            return {
              resp: resp,
              filter: params.wildcard ? params.wildcard : "",
            };
          })
          .catch((e) => {
            throw e;
          });
      },
      assignAgent(opportunity, agent) {
        let data = {
          agentId: agent.id,
          opportunityId: opportunity.id,
        };

        return request.post(
          "/interviews-api/agent-connection/forceReferralAssignment",
          data,
        );
      },
      deleteAssignedAgent(opportunity, data) {
        return request.delete(
          `/interviews-api/opportunities/${opportunity.id}/assignedAgent`,
          data,
        );
      },
      postNote(opportunity, data) {
        return request.post(
          `/interviews-api/opportunities/${opportunity.id}/notes`,
          data,
        );
      },
      updateStatus(id, data) {
        return request.put(`/interviews-api/opportunities/${id}/status`, data);
      },
      getInteractions(params) {
        params.pageIndex = params.pageIndex ? params.pageIndex : 0;
        params.pageSize = params.pageSize ? params.pageSize : 100;

        return request.get(`/interviews-api/interactions`, params);
      },
      scheduleCallback(data) {
        return request.post(`/interviews-api/interactions`, data);
      },
      postInteraction(data) {
        return request.post(`/interviews-api/interactions`, data);
      },
      getDispositions() {
        return request.get(
          `/interviews-api/dispositions?sort=category&sort=name,asc&pageSize=1000`,
        );
      },
      getSMSLogs(params) {
        params.pageNumber = params.pageNumber ? params.pageNumber : 0;
        params.pageSize = params.pageSize ? params.pageSize : 100;

        return request.get(`/interviews-api/conversation`, params);
      },
      getTasks(params) {
        return request.get(`/workflow-api/tasks`, params);
      },
    };
  },
};

export default opportunity;
